<template>
    <Head title="MFA" />
    <RegisterLayout title="Multiplo Fator de Autenticação">
        <article class="xl:max-w-[352px] mx-auto">
            <div class="sm:px-5 xl:max-w-full">
                <p class="pb-4">Para mantermos sua conta segura, precisamos garantir que é realmente você tentando acessar a conta:</p>

                <form @submit.prevent="submit" class="mb-6">
                    <ul class="pt-6">
                        <li class="mb-4">
                            <label class="mr-5 flex font-bold pb-1">Email de validação</label>
                            <Input id="contact" v-model="form.contact" type="email" disabled autofocus />
                        </li>

                        <li>
                            <Button :disabled="!allIsValid">
                                Criar Senha
                            </Button>
                        </li>
                    </ul>
                </form>
                <div v-if="$page.props.flash.error">
                    {{ $page.props.flash.error }}
                </div>

                <div v-if="$page.props.flash.success">
                    {{ $page.props.flash.success }}
                </div>
            </div>

        </article>
        <MFAModal v-if="isAuthorizeModalOpen"
        :credentialauthenticationmethods="credential.credentialauthenticationmethods"
        :accessTo="authorizeModal.accessTo"
        :showModal="isAuthorizeModalOpen"
        :defaultCredentialAuthenticationMethodId="authorizeModal.defaultCredentialAuthenticationMethodId"
        :defaultCredentialAuthorizationId="authorizeModal.defaultCredentialAuthorizationId"
        :defaultContact="authorizeModal.defaultContact"
        @onCancel="cancelAuthorizationModalEvent"
        @onSuccess="successAuthorizationModalEvent" />
    </RegisterLayout>
</template>

<script>
import Input from '@/Components/UI/Form/Input.vue';
import Icon from '@/Components/UI/Icons/Icon.vue'
import Button from '@/Components/Button.vue'
import RegisterLayout from "@/Layouts/Register.vue";
import Header from '@/Components/UI/Nav/Header.vue'
import Back from '@/Components/UI/Back.vue'
import { Head, Link } from "@inertiajs/inertia-vue3";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue"
import MFAModal from "@/Components/MFA/Modal.vue";
import getBrowserFingerprint from "get-browser-fingerprint";

export default {
    components: {
        Header,
        Head,
        Input,
        Icon,
        Button,
        Link,
        Back,
        RegisterLayout,
        HeadingGuest,
        MFAModal,
    },
    props: {
        authenticationMethods: Object,
        credential: Object,
        redirect: String,
        defaultContact: String,
    },
    data() {
        return {
            showSuccessModal: false,
            isAuthorizeModalOpen: false,
            defaultAuthorizeModal: {
                defaultCredentialAuthorizationId: '',
                defaultCredentialAuthenticationMethodId: '',
                accessTo: 'confirmation',
                defaultContact: this.defaultContact,
            },
            authorizeModal: {
                defaultCredentialAuthorizationId: '',
                defaultCredentialAuthenticationMethodId: '',
                accessTo: 'confirmation',
                defaultContact: this.defaultContact,
            },
            createdCredentialAuthenticationMethodId: '',
            createdCredentialAuthorizationId: '',
            confirmPassword: "",
            form: this.$inertia.form({
                contact: this.defaultContact,
            }),
        }
    },
    mounted() {
        this.mount();
    },
    methods: {
        mount() {
            this.resetAuthorizationModalObject();
        },
        resetAuthorizationModalObject() {
            this.authorizeModal = this.defaultAuthorizeModal;
        },
        closeAuthorizationModal() {
            this.isAuthorizeModalOpen = false;
        },
        openAuthorizationModal() {
            this.isAuthorizeModalOpen = true;
        },
        cancelAuthorizationModalEvent() {
            this.closeAuthorizationModal();
            this.resetAuthorizationModalObject();
        },
        successAuthorizationModalEvent() {
            this.closeAuthorizationModal();
            this.resetAuthorizationModalObject();
            this.$inertia.get(this.route(this.redirect || 'register.success'));
        },
        submit() {
            if (this.form.contact && this.form.contact.trim() !== "") {
                axios
                    .post(this.route("mfa.create-authenticationmethod"), {
                        authenticationmethodId: this.emailAuthenticationMethod.authenticationmethod?.id,
                        contact: this.form.contact.trim(),
                        fingerprintHash: this.browserFingerprint,
                    })
                    .then(({ data }) => {
                        const error = data.error;
                        this.$page.props.flash.error = '';

                        if (error) {
                            const errorMessage = data.data.message;
                            this.$page.props.flash.error = errorMessage;
                        } else {
                            this.openAuthorizationModal();
                            this.authorizeModal.defaultCredentialAuthenticationMethodId = data.id;
                            this.authorizeModal.defaultCredentialAuthorizationId = data.credentialauthorizationId;
                            this.authorizeModal.defaultContact = data.contact;
                        }
                    })
                    .catch(function (error) {
                        console.log("Erro:", error);
                    });
            }
        },
    },
    computed: {
        allIsValid() {
            return this.form.contact && this.form.contact.trim() !== "";
        },
        browserFingerprint() {
            return getBrowserFingerprint();
        },
        isEnabled() {
            return this.authenticationMethods?.length > 0 && this.credential?.id;
        },
        emailAuthenticationMethod() {
            return this.authenticationMethods?.find(({ authenticationmethod }) => authenticationmethod?.name?.toUpperCase() === 'EMAIL');
        },
    }
}
</script>
